import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ProjectControlItemService,
  ProjectService,
  TenantService,
  UserService
} from '../../_services/index';

import {Router} from '@angular/router';

import {CategoryStatistics, Project, ProjectControlItem, User} from '../../_models/index';

import * as _ from "lodash";

import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';

import {ProjectControlItemComponent} from '../projectControlItem';

import {DatesHelper, LoginHelper, Recurring, Role, StringsHelper} from '../../helpers';

import {Bulletin} from "../../_models/bulletin";
import {BulletinService} from "../../_services/bulletin.service";
import {BulletinComponent} from "../bulletin";
import {EditBulletinComponent} from "../editBulletin";
import {CreateBulletinComponent} from "../createBulletin";
import {Table} from "primeng/table";
import * as moment from "moment"
import {ActionPlan} from "../../_models/actionPlan";
import {PolicyService} from "../../_services/policy.service";
import {Policy} from "../../_models/policy";
import {IndexConfigService} from "../../_services/index.config.service";
import {TrainingService} from "../../_services/training.service";
import {AssessmentService} from "../../_services/assessment.service";

const DashboardWidgets = 'DashboardWidgets';

@Component({
    standalone: false,
  selector: "home",
  templateUrl: 'home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class HomeComponent implements OnInit {

  projectControlItemsToReviewRowGroupMetadata: any = {};
  projectControlItemsToCompleteRowGroupMetadata: any = {};
  @ViewChild('dt') table: Table;
  firstProjectNameToComplete: string;
  firstProjectNameToReview: string;
  projects: Project[] = null;
  selectedProject: Project;
  selectedProjectControlItems: ProjectControlItem[];
  selectedProjectControlItemsAwaitingReview: ProjectControlItem[];
  selectedProjectControlItemsWithoutEvidence: ProjectControlItem[];
  projectControlItemsToComplete: ProjectControlItem[];
  projectControlItemsToReview: ProjectControlItem[];
  selectedProjectCategoriesStatistics: CategoryStatistics[];
  msg: string;
  currentUser: User;
  data: any;
  projectStatusPercentageData: any;
  projectStatusLevelPercentageData: any;
  implementationStatusData: any;
  gapsData: any;
  allGapsData: any;
  gapsOptions: any;
  allGapsOptions: any;
  trainingData: any;
  surveyData: any;
  //barOptions: any;
  projectStatusBarOptions: any;
  projectStatusPercenatgeBarOptions: any;
  projectStatusLevelPercenatgeBarOptions: any;
  implementationStatusBarOptions: any;
  trainingOptions: any;
  surveyOptions: any;
  dashboards: boolean[];
  bulletins: Bulletin[];
  actionPlans: ActionPlan[];
  filteredActionPlans: ActionPlan[];
  actionPlanRowGroupMetadata: any = {};
  implementationStatusCount: any;
  policies: Policy[];
  users: User[];
  expandedActionPlanProjects = {};
  totalData: any;
  userToken = LoginHelper.getFileToken();
  completed = 0;
  reviewed = 0;
  notCompleted = 0;

  totalOptions: any;
  widgetOptions = [
    {label: 'Control Implementation Status', value: 'Control Implementation Status'},
    {label: 'Gaps', value: 'Gaps'},
    {label: 'Recurring Tasks', value: 'Recurring Tasks'},
    {label: 'Gaps - All Projects', value: 'Gaps - All Projects'},
    {label: 'Project Level Status', value: 'Project Level Status'},
    {label: 'Projects Totals', value: 'Projects Totals'},
    {label: 'Controls to Complete This Month - All Projects', value: 'Controls to Complete This Month - All Projects'},
    {label: 'Policies Requiring Approval', value: 'Policies Requiring Approval'},
    {label: 'All Open Controls', value: 'All Open Controls'},
    {label: 'Controls Awaiting Review', value: 'Controls Awaiting Review'},
    {label: 'Recently Reviewed Controls', value: 'Recently Reviewed Controls'},
    {label: 'Course Status', value: 'Course Status'},
    {label: 'Survey Status', value: 'Survey Status'},
    {label: 'Items Requiring Evidence Attachment', value: 'Items Requiring Evidence Attachment'},
    {label: 'Compliance Bulletins', value: 'Compliance Bulletins'},
  ];
  widgetSettings: any;
  visibleWidgets = [];
  implementationStatuses: any =
    {
      0: "None",
      1: "Implemented",
      2: "Part. Implemented",
      3: "Planned",
      4: "Alt. Implementation",
      5: "Not Applicable",
      /*6: "Ongoing",*/
      7: "Not Implemented"
    };

  poamTitles = ["All POAMs", "High Risk", "Overdue"]

  actionItemStatuses: any =
    {
      0: "Not Started",
      1: "In-Progress",
      2: "Resolved",
      3: "Awaiting Review",
      4: "Reviewed - Not POAM"
    };

  periods: any[] = [
    {name: 'All', value: -1},
    {name: 'Daily', value: 1},
    {name: 'Weekly', value: 2},
    {name: 'Monthly', value: 3},
    {name: 'Quarterly', value: 4},
    {name: 'Yearly', value: 5}
  ];

  selectedFrequency = 1;

  dialogBulletinRef: MatDialogRef<BulletinComponent> | null;
  dialogEditBulletinRef: MatDialogRef<EditBulletinComponent> | null;
  dialogCreateBulletinRef: MatDialogRef<CreateBulletinComponent> | null;

  controlsToCompleteThisMonthCols: any[] = [
    {'field': 'controlItem.complianceAreaControlId', 'header': 'ID'},
    {'field': 'controlItem.category', 'header': 'Control Item'},
    {'field': 'assignedClient.firstName', 'header': 'Control Owner'},
    {'field': 'upcomingDueDate', 'header': 'Due Date'},
  ];

  controlsExpectingEvidenceCols: any[] = [
    {'field': 'controlItem.complianceAreaControlId', 'header': 'ID'},
    {'field': 'controlItem.category', 'header': 'Control Item'},
    {'field': 'assignedClient.firstName', 'header': 'Control Owner'},
    {'field': 'evidenceDueDate', 'header': 'Evidence Due Date'},
  ];

  selectedProjectCategoriesStatisticsCols: any[] = [
    {'field': 'controlItem.name', 'header': 'Control Area'},
    {'field': 'status', 'header': 'Status'},
  ];

  bulletinsCols: any[] = [
    {'field': 'areaName', 'header': 'Control Area'},
    {'field': 'name', 'header': 'Item'},
    {'field': 'type', 'header': 'Type'},
    {'field': 'date', 'header': 'Date'},
  ]
  actionPlanCols: any[] = [
    {'field': 'controlItemId', 'header': 'Control ID'},
    {'field': 'weaknessDescription', 'header': 'Description'},
    {'field': 'owner', 'header': 'Owner', width: '15%'},
    {'field': 'identificationDateValue', 'header': 'Identification Date', width: '15em'},
    {'field': 'currentStatusValue', 'header': 'Status', width: '35%'},
  ]

  //@ViewChild(DashboardComponent) dashboard: DashboardComponent;

  widgetsSize: number[] = [510, 320];
  dashboardMargin: number = 20;
  dialogRef: MatDialogRef<ProjectControlItemComponent> | null;
  tenantName: string;
  isProjectsEnabled = false;

  constructor(
    public projectService: ProjectService,
    public projectControlService: ProjectControlItemService,
    public bulletinService: BulletinService,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public clientProfileService: ClientProfileService,
    public policyService: PolicyService,
    public userService: UserService,
    public config: IndexConfigService,
    public tenantService: TenantService,
    public trainingService: TrainingService,
    public assessmentService: AssessmentService,
    public dialog: MatDialog) {

    this.tenantService.getCurrent().subscribe(p => {
      if (p != null) {
        this.isProjectsEnabled = p.isProjectsEnabled;
      }
    })

    const barOptions = {
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        x: {
          display: false,
          barThickness: 100,
          //categoryPercentage: 1.0,
          //barPercentage: 1.0,
          ticks: {
            color: getComputedStyle(document.documentElement)
              .getPropertyValue('--app-text')
              .trim()
          }
        },
        y: {
          ticks: {
            min: -25
          },
          display: false
        },
      },
      hover: {
        animationDuration: 0
      },
      animation: {
        duration: 0,
        onComplete: function (that) {
          const chartInstance = that.chart,
            ctx = chartInstance.ctx;
          ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--app-text').trim();
          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';

          this.data.datasets.forEach(function (dataset, i) {
            const meta = chartInstance.getDatasetMeta(i);
            meta.data.forEach(function (bar, index) {
              const data = dataset.labels ? dataset.labels[index] : dataset.data[index];

              //console.log(bar);
              //console.log(ctx);

              ctx.font = '12px "Helvetica Neue", Helvetica, Arial, sans-serif'

              ctx.fillText(data, bar.x, bar.base);

              ctx.font = '9px "Helvetica Neue", Helvetica, Arial, sans-serif'
              ctx.fillText(bar.datasetLabel, bar.x, bar.base + 12);
            });
          });
        }
      }
    };

    this.projectStatusBarOptions = _.cloneDeep(barOptions);//Object.assign({}, barOptions);
    this.projectStatusLevelPercenatgeBarOptions = _.cloneDeep(barOptions)
    this.projectStatusPercenatgeBarOptions = _.cloneDeep(barOptions); //Object.assign({}, barOptions);

    this.implementationStatusBarOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          displayColors: false,
          callbacks: {
            label: (tooltipItem, data) => {
              return Math.round(tooltipItem.raw * 10000 / tooltipItem.dataset.data.reduce((a, b) => a + b, 0)) / 100 + '%';
            }
          }
        },
      },
      scales: {
        x: {
          display: true,
          barThickness: 0,
          stacked: true,
          gridLines: {
            drawOnChartArea: false,
            color: "rgba(0,0,0,0)"
          },
          ticks: {
            color: getComputedStyle(document.documentElement)
              .getPropertyValue('--app-text')
              .trim()
          }
        },
        y: {
          stacked: true,
          ticks: {
            min: 0
          },
          gridLines: {
            color: "rgba(0,0,0,0)"
          },
          display: false
        },
      },
      hover: {
        animationDuration: 0
      },
      animation: {
        duration: 0,
        onComplete: function (that) {
          const chartInstance = that.chart,
            ctx = chartInstance.ctx;
          ctx.textAlign = 'center';
          ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--app-text').trim(); //"rgba(0, 0, 0, 1)";
          ctx.textBaseline = 'bottom';

          this.data.datasets.forEach(function (dataset, i) {
            const meta = chartInstance.getDatasetMeta(i);
            meta.data.forEach(function (bar, index) {
              const data = dataset.data[index];

              //console.log(bar);
              //console.log(ctx);
              return;
              ctx.font = '12px "Helvetica Neue", Helvetica, Arial, sans-serif'

              ctx.fillText(data, bar.x, bar.base);

              ctx.font = '9px "Helvetica Neue", Helvetica, Arial, sans-serif'
              ctx.fillText(bar.datasetLabel, bar.x, bar.base + 12);
            });
          });
        }
      }
    };

    this.gapsOptions = {
      responsive: true,
      maintainAspectRatio: false,
      layout: {padding: {bottom: 5}},
      legend: {
        display: false
      },
      tooltips: {
        callbacks: {
          label: (tooltipItem, data) => {
            return data && data.datasets ? this.poamTitles[tooltipItem.datasetIndex] + ":" + data.datasets[tooltipItem.datasetIndex].data[0] : '';
          }
        }
      },
      scales: {
        x: {
          display: true,
          barThickness: 0,
          gridLines: {
            drawOnChartArea: false,
            color: "rgba(0,0,0,0)"
          },
          ticks: {
            color: getComputedStyle(document.documentElement)
              .getPropertyValue('--app-text')
              .trim()
          }
          //categoryPercentage: 1.0,
          //barPercentage: 1.0,
        },
        y: {
          ticks: {
            min: 0
          },
          gridLines: {
            color: "rgba(0,0,0,0)"
          },
          display: false
        },
      },
      hover: {
        animationDuration: 0
      },
      animation: {
        duration: 0,
        onComplete: function (that) {
          const chartInstance = that.chart,
            ctx = chartInstance.ctx;
          ctx.textAlign = 'center';
          ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--app-text').trim(); //"rgba(0, 0, 0, 1)";
          ctx.textBaseline = 'bottom';

          this.data.datasets.forEach(function (dataset, i) {
            const meta = chartInstance.getDatasetMeta(i);
            meta.data.forEach(function (bar, index) {
              const data = dataset.data[index];

              //console.log(bar);
              //console.log(ctx);

              ctx.font = '12px "Helvetica Neue", Helvetica, Arial, sans-serif'

              ctx.fillText(data.y, bar.x, bar.base || 0);

              ctx.font = '9px "Helvetica Neue", Helvetica, Arial, sans-serif'
              ctx.fillText(dataset.label, bar.x, (bar.base || 0) + 12);
            });
          });
        }
      }
    };

    this.allGapsOptions = {
      responsive: true,
      maintainAspectRatio: false,
      layout: {padding: {bottom: 5}},
      legend: {
        display: false
      },
      tooltips: {
        callbacks: {
          label: (tooltipItem, data) => {
            return data && data.datasets ? this.poamTitles[tooltipItem.datasetIndex] + ":" + data.datasets[tooltipItem.datasetIndex].data[0] : '';
          }
        }
      },
      scales: {
        x: {
          display: true,
          barThickness: 0,
          gridLines: {
            drawOnChartArea: false,
            color: "rgba(0,0,0,0)"
          },
          ticks: {
            color: getComputedStyle(document.documentElement)
              .getPropertyValue('--app-text')
              .trim()
          },
          //categoryPercentage: 1.0,
          //barPercentage: 1.0,
        },
        y: {
          ticks: {
            min: 0
          },
          gridLines: {
            color: "rgba(0,0,0,0)"
          },
          display: false
        },
      },
      hover: {
        animationDuration: 0
      },
      animation: {
        duration: 0,
        onComplete: function (that) {
          const chartInstance = that.chart,
            ctx = chartInstance.ctx;
          ctx.textAlign = 'center';
          ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--app-text').trim(); //"rgba(0, 0, 0, 1)";
          ctx.textBaseline = 'bottom';

          this.data.datasets.forEach(function (dataset, i) {
            const meta = chartInstance.getDatasetMeta(i);
            meta.data.forEach(function (bar, index) {
              const data = dataset.data[index];

              //console.log(bar);
              //console.log(ctx);

              ctx.font = '12px "Helvetica Neue", Helvetica, Arial, sans-serif'

              ctx.fillText(data.y, bar.x, bar.base || 0);

              ctx.font = '9px "Helvetica Neue", Helvetica, Arial, sans-serif'
              ctx.fillText(dataset.label, bar.x, (bar.base || 0) + 12);
            });
          });
        }
      }
    };

    this.trainingService.getAllTrainings().subscribe(t => {
      let i;
      this.trainingOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              return data && data.datasets ? (tooltipItem.datasetIndex == 0 ? "Submissions " : "Assigned ") + ":" + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] : '';
            }
          }
        },
        scales: {
          x: {
            display: true,
            barThickness: 0,
            gridLines: {
              drawOnChartArea: false,
              color: "rgba(0,0,0,0)"
            },
            ticks: {
              color: getComputedStyle(document.documentElement)
                .getPropertyValue('--app-text')
                .trim()
            },
          },
          y: {
            ticks: {
              min: 0
            },
            gridLines: {
              color: "rgba(0,0,0,0)"
            },
            display: false
          },
        },
        hover: {
          animationDuration: 0
        },
        animation: {
          duration: 0,
          onComplete: function (that) {
            const chartInstance = that.chart,
              ctx = chartInstance.ctx;
            ctx.textAlign = 'center';
            ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--app-text').trim(); //"rgba(0, 0, 0, 1)";
            ctx.textBaseline = 'bottom';

            this.data.datasets.forEach(function (dataset, i) {
              const meta = chartInstance.getDatasetMeta(i);
              meta.data.forEach(function (bar, index) {
                const data = dataset.data[index];

                //console.log(bar);
                //console.log(ctx);

                ctx.font = '12px "Helvetica Neue", Helvetica, Arial, sans-serif'

                ctx.fillText(data, bar.x, bar.base);

                ctx.font = '9px "Helvetica Neue", Helvetica, Arial, sans-serif'
                ctx.fillText(bar.datasetLabel, bar.x, bar.base + 12);
              });
            });
          }
        }
      };

      this.trainingData = {
        labels: [],
        datasets: [{
          label: '',
          backgroundColor: this.cssVar('--main-ui-color'),
          data: []
        }, {
          label: '',
          backgroundColor: '#18044a',
          data: []
        }]
      };

      for (i = 0; i < t.length; i++) {
        this.trainingData.labels.push(t[i].quizData.name);
        this.trainingData.datasets[0].data.push((t[i].submissions || 0));
        this.trainingData.datasets[1].data.push((t[i].trainingUsers || []).length > 0 ? (t[i].trainingUsers || []).length : 0);
      }
    });
    this.assessmentService.getAllAssessments().subscribe(t => {
      let i;
      this.surveyOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              return data && data.datasets ? (tooltipItem.datasetIndex == 0 ? "Submissions " : "Assigned ") + ":" + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] : '';
            }
          }
        },
        scales: {
          x: {
            display: true,
            barThickness: 0,
            gridLines: {
              drawOnChartArea: false,
              color: "rgba(0,0,0,0)"
            },
            ticks: {
              color: getComputedStyle(document.documentElement)
                .getPropertyValue('--app-text')
                .trim()
            },
          },
          y: {
            ticks: {
              min: 0
            },
            gridLines: {
              color: "rgba(0,0,0,0)"
            },
            display: false
          },
        },
        hover: {
          animationDuration: 0
        },
        animation: {
          duration: 0,
          onComplete: function (that) {
            const chartInstance = that.chart,
            ctx = chartInstance.ctx;
            ctx.textAlign = 'center';
            ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--app-text').trim();  //"rgba(0, 0, 0, 1)";
            ctx.textBaseline = 'bottom';

            this.data.datasets.forEach(function (dataset, i) {
              const meta = chartInstance.getDatasetMeta(i);
              meta.data.forEach(function (bar, index) {
                const data = dataset.data[index];

                //console.log(bar);
                //console.log(ctx);

                ctx.font = '12px "Helvetica Neue", Helvetica, Arial, sans-serif'

                ctx.fillText(data, bar.x, bar.base);

                ctx.font = '9px "Helvetica Neue", Helvetica, Arial, sans-serif'
                ctx.fillText(bar.datasetLabel, bar.x, bar.base + 12);
              });
            });
          }
        }
      };

      this.surveyData = {
        labels: [],
        datasets: [{
          label: '',
          backgroundColor: '#6200db',
          data: []
        }, {
          label: '',
          backgroundColor: '#18044a',
          data: []
        }]
      };

      for (i = 0; i < t.length; i++) {
        this.surveyData.labels.push(t[i].quizData.name);
        this.surveyData.datasets[0].data.push((t[i].submissions || 0));
        this.surveyData.datasets[1].data.push((t[i].assessmentUsers || []).length > 0 ? (t[i].assessmentUsers || []).length : 0);
      }
    });


    this.dashboards = [true, true, true];
  }

  cssVar(name: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  }

  fillTotalsDashboards() {
    this.completed = this.selectedProject.itemsCount - this.selectedProject.itemsRemaining;
    this.reviewed = this.selectedProject.itemsReviewed;
    this.notCompleted = this.selectedProject.itemsRemaining;
    if (this.selectedFrequency >= 0) {
      this.completed = this.selectedProject.countsByFrequency[this.selectedFrequency].itemsCount - this.selectedProject.countsByFrequency[this.selectedFrequency].itemsRemaining;
      this.reviewed = this.selectedProject.countsByFrequency[this.selectedFrequency].itemsReviewed;
      this.notCompleted = this.selectedProject.countsByFrequency[this.selectedFrequency].itemsRemaining;
    }

    this.data = {
      labels: [''
        //['Completed'],
        //['Completed1'], ['& Certified'],
        //['Not'], ['Completed']
      ],
      datasets: [
        {
          label: 'Completed',
          backgroundColor: '#6200db',
          //borderColor: '#1E88E5',
          data: [this.getValue(this.selectedProject.itemsCount - this.selectedProject.itemsRemaining)]
        },
        {
          label: 'Reviewed',
          backgroundColor: '#18044a',
          //borderColor: '#1E88E5',
          data: [this.getValue(this.selectedProject.itemsReviewed)]
        },
        {
          label: 'Not Completed',
          backgroundColor: '#525252',
          //borderColor: '#7CB342',
          data: [this.getValue(this.selectedProject.itemsRemaining)]
        }
      ]
    };

    const max = Math.max(this.completed, this.reviewed, this.notCompleted);
    const min = Math.min(this.completed, this.reviewed, this.notCompleted);

    const maxMin = max - min;

    this.projectStatusBarOptions.scales.y = {
      ticks: {
        min: -(maxMin / 10)
      },
      display: false
    };

    const completedPercentage = this.getPercentage(this.completed + this.notCompleted > 0 ? this.getStatusPercentage(this.completed, this.completed + this.notCompleted) : 100);
    const notCompletedPercentage = this.getPercentage(this.completed + this.notCompleted > 0 ? this.getStatusPercentage(this.notCompleted, this.completed + this.notCompleted) : 0);

    this.projectStatusPercentageData = {
      labels: ['Completed', 'Not Completed'],
      datasets: [
        {
          label: 'Completed',
          //backgroundColor: ['#FE652C', '#d36576'],
          backgroundColor: ['#6200db', '#18044a'],
          //borderColor: '#1E88E5',
          borderWidth: 0,
          borderColor: 'transparent',
          hoverBorderWidth: 0,
          data: [completedPercentage, notCompletedPercentage]
        },
      ]
    };

    this.projectStatusLevelPercentageData = {
      labels: [''],
      datasets: []
    };
    //const colors = ['#FE652C', '#1E88E5', '#d36576', '#f43f5c', '#2f4b7c', '#a0f1f5'];
    // old color scheme -> new, orange/blue/red to purple/dark purple/gray
    const colors = ['#6200db', '#18044a', '#525252', '#f43f5c', '#2f4b7c', '#a0f1f5'];
    for (let i = 0; i < (this.selectedProject.levels || []).length; i++) {
      this.projectStatusLevelPercentageData.datasets.push({
          label: this.selectedProject.levels[i].name,
          backgroundColor: colors[i],
          data: [Math.round(this.selectedProject.levels[i].itemsCompleted / this.selectedProject.levels[i].itemsCount * 100)],
          labels: [Math.round(this.selectedProject.levels[i].itemsCompleted / this.selectedProject.levels[i].itemsCount * 100) + '%']
        },
      );
    }
    console.log(this.projectStatusLevelPercentageData)


    const maxPercentage = Math.max(completedPercentage, notCompletedPercentage);
    const minPercentage = Math.min(completedPercentage, notCompletedPercentage);

    const maxMinPercentage = maxPercentage - minPercentage;

    this.projectStatusPercenatgeBarOptions.scales.y = {
      ticks: {
        min: maxMinPercentage / 10 < 10 ? -5 : -(maxMinPercentage / 10)
      },
      display: false
    };

    this.projectStatusLevelPercenatgeBarOptions.scales.y = {
      ticks: {
        min: 0
      },
      display: false
    };
  }

  getValue(value: number): string {
    return value == 0 || value == null ? "0" : value.toString();
  }

  getPercentage(value: number): number {
    return value == 0 ? 0 : value;
  }

  //----------------------
  static itemChange(item, itemComponent) {
    //console.info('itemChanged', item, itemComponent);
  }

  static itemResize(item, itemComponent) {
    //console.info('itemResized', item, itemComponent);
  }

  //----------------------

  ngOnInit() {
    this.clientProfileService.getUserSetting(DashboardWidgets).subscribe(s => {
      this.widgetSettings = s || {};
      this.visibleWidgets = [];
      this.widgetOptions.forEach(w => {
        this.widgetSettings[w.label] = (this.widgetSettings[w.label] || {visible: w.value !== 'Project Level Status'});
        if (this.widgetSettings[w.label].visible !== false) {
          this.visibleWidgets.push(w.value);
        }
      });
    });
    /*
    this.options = {
      //gridType: GridType.Fit,
      //compactType: CompactType.None,
      //initCallback: AppComponent.gridInit,
      //destroyCallback: AppComponent.gridDestroy,
      //itemChangeCallback: AppComponent.itemChange,
      //itemResizeCallback: AppComponent.itemResize,
      //itemInitCallback: AppComponent.itemInit,
      //itemRemovedCallback: AppComponent.itemRemoved,

      margin: 10,
      outerMargin: true,
      outerMarginTop: null,
      outerMarginRight: null,
      outerMarginBottom: null,
      outerMarginLeft: null,
      mobileBreakpoint: 640,
      minCols: 1,
      maxCols: 100,
      minRows: 1,
      maxRows: 100,
      maxItemCols: 100,
      minItemCols: 1,
      maxItemRows: 100,
      minItemRows: 1,
      maxItemArea: 2500,
      minItemArea: 1,
      defaultItemCols: 1,
      defaultItemRows: 1,
      fixedColWidth: 105,
      fixedRowHeight: 105,
      keepFixedHeightInMobile: false,
      keepFixedWidthInMobile: false,
      scrollSensitivity: 10,
      scrollSpeed: 20,
      enableEmptyCellClick: false,
      enableEmptyCellContextMenu: false,
      enableEmptyCellDrop: false,
      enableEmptyCellDrag: false,

      //emptyCellClickCallback: this.emptyCellClick.bind(this),
      //emptyCellContextMenuCallback: this.emptyCellClick.bind(this),
      //emptyCellDropCallback: this.emptyCellClick.bind(this),
      //emptyCellDragCallback: this.emptyCellClick.bind(this),

      emptyCellDragMaxCols: 50,
      emptyCellDragMaxRows: 50,
      ignoreMarginInRow: false,
      draggable: {
        delayStart: 0,
        enabled: true,
        ignoreContentClass: 'gridster-item-content',
        ignoreContent: false,
        dragHandleClass: 'drag-handler',
        //stop: AppComponent.eventStop
      },
      resizable: {
        delayStart: 0,
        enabled: true,
        //stop: AppComponent.eventStop,
        handles: {
          s: true,
          e: true,
          n: true,
          w: true,
          se: true,
          ne: true,
          sw: true,
          nw: true
        }
      },
      swap: false,
      pushItems: true,
      disablePushOnDrag: false,
      disablePushOnResize: false,
      pushDirections: {north: true, east: true, south: true, west: true},
      pushResizeItems: false,
      //displayGrid: DisplayGrid.Always,
      disableWindowResize: false,
      disableWarnings: false,
      scrollToNewItems: false
    };

    this.dashboard = [
      {cols: 2, rows: 1, y: 0, x: 0},
      {cols: 2, rows: 2, y: 0, x: 2, hasContent: true},
      {cols: 1, rows: 1, y: 0, x: 4},
      {cols: 1, rows: 1, y: 2, x: 5},
      {cols: undefined, rows: undefined, y: 1, x: 0},
      {cols: 1, rows: 1, y: undefined, x: undefined},
      {cols: 2, rows: 2, y: 3, x: 5, minItemRows: 2, minItemCols: 2, label: 'Min rows & cols = 2'},
      {cols: 2, rows: 2, y: 2, x: 0, maxItemRows: 2, maxItemCols: 2, label: 'Max rows & cols = 2'},
    ];
    */

    //console.log(this.table);

    this.tenantName = LoginHelper.getTenantName();

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.userService.getAllShort().subscribe(u => this.users = u);
    this.loadAllProjects();
    this.loadBulletins();
    this.loadPolicies();

  }


  editControlItemToComplete(projectControlItemId: number) {

    let projectControlItem =
      this.projectControlItemsToComplete.find(x => x.projectControlItemId == projectControlItemId);

    this.editControlItem(projectControlItem);
  }

  editControlItemToReview(projectControlItemId: number) {

    let projectControlItem =
      this.projectControlItemsToReview.find(x => x.projectControlItemId == projectControlItemId);

    this.editControlItem(projectControlItem);
  }

  editRecurringControlItem(projectControlItemId: number) {
    this.router.navigate(['/projects/project', this.selectedProject.projectId, projectControlItemId]);
  }

  editControlItem(projectControlItem: ProjectControlItem) {
    this.router.navigate(['/projects/project', projectControlItem.projectId, projectControlItem.projectControlItemId]);

    /*  let config: MatDialogConfig = {
        panelClass: 'custom-overlay-pane-class',
        width: 'auto',
        height: '600px',
        data: {
          projectControlItem: projectControlItem
        }
      };

      this.dialogRef = this.dialog.open(ProjectControlItemComponent, config);

      this.dialogRef.afterClosed().subscribe((result: any) => {
        this.loadSelectedProject();
      });*/
  }

  loadSelectedProject() {

    let max;
    const labels = ['# of POAMs', '# high risk', '# overdue'];
    let dateNow = new Date(Date.now());
    const nextMonth = new Date(dateNow.setMonth(dateNow.getMonth() + 1)).toISOString();
    dateNow = new Date(Date.now());
    const lastTwoweek = new Date(dateNow.setMonth(dateNow.getDate() - 14)).toISOString();

    this.projectService.getByIdAndDueDate(this.selectedProject.projectId, nextMonth).subscribe(
      data => {
        //this.selectedProject = data;
        this.selectedProjectControlItems = data.projectControlItems;
        data.projectControlItems.forEach(p => p.dueDate = DatesHelper.GetUpcomingDate(p, false).value);
        this.selectedProjectControlItemsAwaitingReview = data.projectControlItems.filter(i => i.reviewRequired);
        this.selectedProjectCategoriesStatistics = data.categoriesStatistics;

      },
      error => {
        const errorMessage = 'An error occurred while loading project.';
        this.alertService.error(errorMessage);
      });

    this.projectService.getImplementationStatus(this.selectedProject.projectId, this.selectedFrequency).subscribe(
      data => {
        //this.selectedProject = data;
        this.implementationStatusCount = data;

        this.implementationStatusData = {
          labels: [],
          datasets: [{
            label: '',
            //backgroundColor: '#FE652C',
            backgroundColor: '#6200db',
            data: []
          }]
        };

        //const colors = ['#FE652C', '#1E88E5', '#d36576', '#f43f5c', '#2f4b7c', '#a0f1f5'];
        // old color scheme -> new, orange/blue/red to purple/dark purple/gray
        const colors = ['#6200db', '#18044a', '#525252', '#f43f5c', '#2f4b7c', '#a0f1f5'];

        let max = 0;
        for (let i = 0; i <= 7; i++) {
          if (data[i]) {
            this.implementationStatusData.labels.push(this.implementationStatuses[i]);
            this.implementationStatusData.datasets[0].data.push(data[i] || 0);
            /*this.implementationStatus.datasets.push({
              label: this.implementationStatuses[i],
              backgroundColor: '#d36576',
              data: [data[i]]
            });*/
            //this.implementationStatus.datasets[0].data.push(data[i] || 0);
            /*this.implementationStatusData.datasets.push({
              label: this.implementationStatuses[i],
              backgroundColor: colors[i],
              data: [{x: i, y: data[i] || 0, label: labels[i]}]
            });*/
            //this.implementationStatus.labels.push(this.implementationStatuses[i]);
            max = Math.max(max, data[i]);
          }
        }


        this.implementationStatusBarOptions.scales.y = {
          /*ticks: {
            max: max
          },*/
          display: false
        };

      },
      error => {
        const errorMessage = 'An error occurred while loading project.';
        this.alertService.error(errorMessage);
      });

    this.projectService.getWithoutEvidence(this.selectedProject.projectId).subscribe(
      data => {
        //this.selectedProject = data;
        this.selectedProjectControlItemsWithoutEvidence = data.projectControlItems;
      },
      error => {
        const errorMessage = 'An error occurred while loading project.';
        this.alertService.error(errorMessage);
      });

    this.projectControlService.getAllByUser(this.currentUser.userId, nextMonth).subscribe(data => {

      data.forEach(x => x.upcomingDueDate = DatesHelper.GetUpcomingDate(x, true));
      this.projectControlItemsToComplete = data.filter(x => !DatesHelper.IsCompletedNow(x));
      this.projectControlItemsToComplete.forEach(p => p.dueDate = DatesHelper.GetUpcomingDate(p, false).value);
      if (this.projectControlItemsToComplete.length > 0) {
        this.firstProjectNameToComplete = this.projectControlItemsToComplete[0].projectName;
      }
      this.updateProjectControlItemsToCompleteGrouping();
    });

    this.projectControlService.getRecentlyReviewed(this.currentUser.userId, lastTwoweek).subscribe(data => {
      this.projectControlItemsToReviewRowGroupMetadata = {};
      this.updateRowGroupMetaData(data, this.projectControlItemsToReviewRowGroupMetadata, (i) => i.projectName)
      this.projectControlItemsToReview = data;
      this.projectControlItemsToReview.forEach(p => p.dueDate = DatesHelper.GetUpcomingDate(p, false).value);
      if (this.projectControlItemsToReview.length > 0) {
        this.firstProjectNameToReview = this.projectControlItemsToReview[0].projectName;
      }
    });

    this.loadActionPlans();

    this.gapsData = {
      labels: [],
      datasets: []
    };

    //const colors = ['#FE652C', '#1E88E5', '#d36576', '#f43f5c', '#2f4b7c', '#a0f1f5'];
    // old color scheme -> new, orange/blue/red to purple/dark purple/gray
    const colors = ['#6200db', '#18044a', '#525252', '#f43f5c', '#2f4b7c', '#a0f1f5'];

    max = 0;
    this.gapsOptions.scales.y.ticks.max = this.selectedProject.poamControlTotal;
    this.gapsData.datasets.push({
      label: labels[0],
      backgroundColor: colors[0],
      data: [{x: 1, y: this.selectedProject.poamCount}]
    });
    this.gapsData.datasets.push({
      label: labels[1],
      backgroundColor: colors[1],
      data: [{x: 2, y: this.selectedProject.highRiskCount}]
    });
    this.gapsData.datasets.push({
      label: labels[2],
      backgroundColor: colors[2],
      data: [{x: 3, y: this.selectedProject.overdueCount}]
    });
    console.log(this.gapsOptions);
    console.log(this.gapsData);
  }

  updateProjectControlItemsToCompleteGrouping() {
    this.projectControlItemsToCompleteRowGroupMetadata = {};
    this.updateRowGroupMetaData(this.projectControlItemsToComplete, this.projectControlItemsToCompleteRowGroupMetadata, (i) => i.projectName);
  }

  selectBar(event) {

    //console.log(event);

    const url = 'projects/project/' + this.selectedProject.projectId;
    const queryParams: any = {};

    switch (event.element.datasetLabel) {

      case "Completed":
        queryParams.completed = true;
        break;

      case "Reviewed":
        queryParams.completed = true;
        queryParams.reviewedByConsultant = true;
        break;

      case "Not Completed":
        queryParams.completed = false;
        break;

      default:
        break;
    }

    this.router.navigate([url], {queryParams: queryParams});
  }

  openCategory(category: string) {

    const url = 'projects/project/' + this.selectedProject.projectId;
    this.router.navigate([url], {queryParams: {category: category}});
  }

  getCategoryStatusColor(status: string) {

    if (status.endsWith("Reviewed By Advisor")) {
      return "Green";
    } else if (status.endsWith("Awaiting Review")) {
      return "Orange";
    } else if (status.indexOf("Open Item") > 0) {
      return "Red";
    } else {
      return "Black";
    }
  }

  log(type: string) {
    //console.log(widget, type);
  }

  logOrder(order: Array<string>) {
    console.log(order, 'orderchange');
  }

  onProjectChange(event: any) {

    this.fillTotalsDashboards();

    this.selectedProjectControlItems = null;
    this.selectedProjectCategoriesStatistics = null;
    this.loadSelectedProject();
  }

  onFrequencyChange(event: any) {
    this.fillTotalsDashboards();
  }

  closeDashboard(event, dashboardNumber: number) {

    this.dashboards[dashboardNumber] = false;
    //console.log(event);
    //console.log(dashboardNumber);
  }

  onCloseDashboard() {
  }

  isHiddenDashboard(dashboardNumber: number) {

    return this.dashboards[dashboardNumber];
    //var field = this.cols.find(x => x.field == fieldName);
    //return field == null ? true : false;
  }

  public loadAllProjects() {

    const prjs: any = this.projectService.getUsersAllProjects(this.currentUser.userId);

    prjs.subscribe((projects: Project[]) => {
        let i;
        this.projects = projects;


        this.clientProfileService.getSettings(LoginHelper.getTenantName()).subscribe(t => {
          this.selectedProject = this.projects.find(f => f.projectId == t.defaultProject) || (this.projects.length > 0 ? this.projects[0] : null);
          this.fillTotalsDashboards();
          this.loadSelectedProject();
        });

        if (this.selectedProject != null) {

          //console.log(this.selectedProject);

        }

        this.totalOptions = {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                return data && data.datasets ? ("Competed : " + data.datasets[0].data[tooltipItem.index] + "\r\nRemaining : " + data.datasets[1].data[tooltipItem.index]) : '';
              }
            }
          },
          scales: {
            x: {
              display: true,
              barThickness: 0,
              stacked: true,
              gridLines: {
                drawOnChartArea: false,
                color: "rgba(0,0,0,0)"
              },
              ticks: {
                color: getComputedStyle(document.documentElement)
                  .getPropertyValue('--app-text')
                  .trim()
              }
            },
            y: {
              stacked: true,
              ticks: {
                min: 0
              },
              gridLines: {
                color: "rgba(0,0,0,0)"
              },
              display: false
            },
          },
          hover: {
            animationDuration: 0
          },
          animation: {
            duration: 0,
            onComplete: function (that) {
              const chartInstance = that.chart,
                ctx = chartInstance.ctx;
              ctx.textAlign = 'center';
              ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--app-text').trim(); //"rgba(0, 0, 0, 1)";
              ctx.textBaseline = 'bottom';

              this.data.datasets.forEach(function (dataset, i) {
                const meta = chartInstance.getDatasetMeta(i);
                meta.data.forEach(function (bar, index) {
                  const data = dataset.data[index];

                  //console.log(bar);
                  //console.log(ctx);
                  return;
                  ctx.font = '12px "Helvetica Neue", Helvetica, Arial, sans-serif'

                  ctx.fillText(data, bar.x, bar.base);

                  ctx.font = '9px "Helvetica Neue", Helvetica, Arial, sans-serif'
                  ctx.fillText(bar.datasetLabel, bar.x, bar.base + 12);
                });
              });
            }
          },
          legendCallback: function (chart) {
            const text = [];
            text.push('<ul class="' + chart.id + '-legend">');
            for (let i = 0; i < chart.data.datasets.length; i++) {
              text.push('<li><span style="background-color:' +
              //chart.data.datasets[i].backgroundColor +
                this.cssVar('--main-ui-color') + 
                '"></span>');
              if (chart.data.datasets[i].label) {
                text.push(chart.data.datasets[i].label);
              }
              text.push('</li>');
            }
            text.push('</ul>');
            return text.join('');
          }
        };

        this.totalData = {
          labels: [],
          datasets: [{
            label: '',
            backgroundColor: '#6200db',
            data: []
          }, {
            label: '',
            backgroundColor: '#18044a',
            data: []
          }]
        };

        this.allGapsData = {
          labels: [''],
          datasets: []
        };

      //const colors = ['#FE652C', '#1E88E5', '#d36576', '#f43f5c', '#2f4b7c', '#a0f1f5'];
      // old color scheme -> new, orange/blue/red to purple/dark purple/gray
      const colors = ['#6200db', '#18044a', '#525252', '#f43f5c', '#2f4b7c', '#a0f1f5'];

        const max = 0;
        const labels = ['# of POAMs', '# high risk', '# overdue'];
        this.allGapsData.datasets.push({
          label: labels[0],
          backgroundColor: colors[0],
          data: [{x: 0, y: 0}]
        });
        this.allGapsData.datasets.push({
          label: labels[1],
          backgroundColor: colors[1],
          data: [{x: 1, y: 0}]
        });
        this.allGapsData.datasets.push({
          label: labels[2],
          backgroundColor: colors[2],
          data: [{x: 2, y: 0}]
        });
        this.allGapsOptions.scales.y.ticks.max = 0;

        for (i = 0; i < projects.length; i++) {
          this.totalData.labels.push(projects[i].name);
          this.totalData.datasets[0].data.push(projects[i].itemsCount - projects[i].itemsRemaining);
          this.totalData.datasets[1].data.push(projects[i].itemsRemaining);
          this.allGapsOptions.scales.y.ticks.max += projects[i].poamControlTotal;
          this.allGapsData.datasets[0].data[0].y += projects[i].poamCount;
          this.allGapsData.datasets[1].data[0].y += projects[i].highRiskCount;
          this.allGapsData.datasets[2].data[0].y += projects[i].overdueCount;
        }

      },

      error => {
        const errorMessage = 'An error occurred while loading projects.';
        this.alertService.error(errorMessage);
      });
  }

  public loadActionPlans() {
    this.projectService.getActionPlans(this.currentUser.userId).subscribe(c => {
      this.actionPlans = c;
      c.forEach(a => {
        a.identificationDateValue = a.identificationDate ? new Date(a.identificationDate).toLocaleDateString() : '';
        a.currentStatusValue = this.actionItemStatuses[a.currentStatus];
      })
      this.filterActionPlan(2);
    })
  }

  getStatusPercentage(count, itemsCount) {
    return Math.round(
      (count / itemsCount) * 1000) / 10;
  }

  openProject(projectId: number) {
    this.router.navigate(['/projects/project', projectId]);
  }

  createProject() {
    this.router.navigate(['/projects/project/create']);
  }

  getProjectClient(project: Project) {
    return project.assignedUsers.filter(x => (x.role & (Role.Manager | Role.PrimaryManager)) != 0).map(u => this.getFullName(u)).join(', ');
  }

  getProjectConsultant(project: Project) {
    return project.assignedUsers.filter(x => (x.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0).map(u => this.getFullName(u)).join(', ');
  }

  getFullName(user: User): string {

    return StringsHelper.getFullName(user);
  }

  bulletinRowClick(bulletin: Bulletin) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '60%',
      height: '600px',
      data: {
        bulletin: bulletin
      }
    };

    this.dialogBulletinRef = this.dialog.open(BulletinComponent, config);
  }

  loadBulletins() {
    this.bulletinService.getForTenant().subscribe(data => {
      this.bulletins = data;
    });
  }

  /*
  onWidget1() {
    if (this.projects.length > 0){
      this.router.navigate(['/projects/project', this.projects[0].projectId]);
    }
  }
  */

  updateRowGroupMetaData(data, metadata, fn) {
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = fn(rowData);
        if (i == 0) {
          metadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = fn(previousRowData);
          if (brand === previousRowGroup)
            metadata[brand].size++;
          else
            metadata[brand] = {index: i, size: 1};
        }
      }
    }
  }

  filterActionPlan(type) {
    this.filteredActionPlans = type == 2 ? this.actionPlans : this.actionPlans.filter(p => p.type == type);
    this.updateActionPlanRowGroupMetaData(this.filteredActionPlans);
  }

  updateActionPlanRowGroupMetaData(data) {
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.projectName;
        if (i == 0) {
          this.actionPlanRowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.projectName;
          if (brand === previousRowGroup)
            this.actionPlanRowGroupMetadata[brand].size++;
          else
            this.actionPlanRowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }

  selectImplementationStatusBar(event) {
    this.router.navigate(['/', 'projects', 'projectNew', this.selectedProject.projectId, 'implementationStatus', event.element._datasetIndex])
  }

  loadPolicies() {
    this.policyService.getAllPolicys().subscribe(t => {
      this.policies = t.filter(p => {
        const closest = moment(p.startDate);
        const step = p.frequency == Recurring.Yearly ? {step: 'year', value: <any>1} :
          p.frequency == Recurring.Quarterly ? {step: 'month', value: <any>3} :
            p.frequency == Recurring.Monthly ? {step: 'month', value: 1} : {step: 'y', value: <any>1};
        while (closest.clone().add(step.value, step.step).isBefore(moment())) {
          closest.add(step.value, step.step);
        }
        let currentApproval;
        for (let i = 0; i < p.approvals.length; i++) {
          if (moment(p.approvals[i].startDate).isSameOrAfter(closest, 'day')) {
            currentApproval = p.approvals[i];
          }
        }
        if (!currentApproval && p.ownerId) {
          return true;
        }
        return false;
      });
    });
  }

  getFullNameById(userId) {
    const user = this.users.find(u => u.userId == userId);
    if (!user) return "";
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  hideWidget(widget) {
    this.widgetSettings[widget] = this.widgetSettings[widget] || {};
    this.widgetSettings[widget].visible = false;
    this.visibleWidgets = this.visibleWidgets.filter(w => w != widget);
    this.clientProfileService.saveUserSetting(DashboardWidgets, this.widgetSettings).subscribe(() => {
    });
  }

  onPanelHide() {
    this.widgetOptions.forEach(w => {
      this.widgetSettings[w.value] = this.widgetSettings[w.value] || {};
      this.widgetSettings[w.value].visible = this.visibleWidgets.filter(v => v === w.value).length > 0;
    });
    this.clientProfileService.saveUserSetting(DashboardWidgets, this.widgetSettings).subscribe(() => {
    });
  }

}
